{
  "greeting": {
    "morning": "Good morning",
    "afternoon": "Good afternoon",
    "evening": "Good evening",
    "withName": "{{greeting}}, {{name}}",
    "nameFallback": "there",
    "todayFormat": "cccc, d LLL yyyy"
  },
  "kpi": {
    "totalMovement": "Total Movement",
    "productionOre": "Production Ore",
    "avgAvailability": "Avg Availability"
  },
  "quickTiles": {
    "operations": "Operations",
    "production": "Production",
    "crushing": "Crushing",
    "rehandle": "Rehandle",
    "stoppages": "Stoppages",
    "drill-blast": "Drill & Blast",
    "stockpiles": "Stockpiles",
    "geology-mvt": "Geology Mvt",
    "ore-tally": "Ore Tally",
    "daily-report": "Daily Report",
    "morning-meeting": "Morning Meeting"
  },
  "cards": {
    "material-movement": {
      "title": "Material Movement",
      "link": "Open Production"
    },
    "plant-status": {
      "title": "Plant Status",
      "link": "Open Stoppages"
    },
    "targets": {
      "title": "Targets",
      "link": "Open Targets"
    },
    "import-checks": {
      "title": "Import Checks",
      "link": "Open Operations"
    },
    "machine-positions": {
      "title": "Machine Positions",
      "link": "Open Machine Positions"
    },
    "drill-blast-today": {
      "title": "Drill & Blast Today",
      "link": "Open Blast Hole Drilling List"
    },
    "explosives-stock": {
      "title": "Explosives Stock",
      "link": "Open Explosives Store"
    },
    "hourly-metrics": {
      "title": "Hourly Metrics",
      "link": "Open Daily Report"
    }
  },
  "frame": {
    "open": "Open {{title}}",
    "live": "LIVE",
    "hideCard": "Hide card",
    "hide": "Hide {{title}}",
    "enterFullscreen": "Enter fullscreen",
    "exitFullscreen": "Exit fullscreen",
    "move": "Move {{title}}",
    "hidden": "{{title}} hidden",
    "undo": "Undo",
    "cards": "Cards",
    "dashboardCards": "Dashboard cards",
    "customise": "Customise",
    "resetToDefault": "Reset to default",
    "done": "Done",
    "noDataTitle": "No data to display",
    "noDataSubtitle": "There's nothing recorded for the selected date and shift.",
    "cardsHidden_one": "Cards · {{count}} hidden",
    "cardsHidden_other": "Cards · {{count}} hidden",
    "hiddenCount_one": "{{count}} hidden",
    "hiddenCount_other": "{{count}} hidden",
    "resizeWidth": "Resize {{title}} width",
    "resizeHeight": "Resize {{title}} height",
    "heights": {
      "short": "short",
      "medium": "medium",
      "tall": "tall"
    },
    "layoutNotSaved": "Your dashboard layout could not be saved",
    "orderNotSaved": "The new tile order could not be saved"
  },
  "live": {
    "latest": "Data displayed for the latest shift",
    "selected": "Data displayed for selected shift",
    "wholeDay": "Data displayed for every shift on this date"
  },
  "material": {
    "emptyTitle": "No material movement",
    "empty": "There's no material movement recorded for the selected date and shift.",
    "offline": "Material movement is totalled by the server, so it cannot be shown while offline. Entries made offline are counted once you reconnect.",
    "total": "Total Material Movement",
    "excavatorLocations": "Production Excavator Locations",
    "drillLocations": "Blasthole Drill Locations",
    "plant": "Plant",
    "measurement": "Measurement",
    "day": "Day",
    "afternoon": "Afternoon",
    "night": "Night",
    "both": "Both",
    "all": "All"
  },
  "plant": {
    "finishCustomising": "Finish customising the dashboard first",
    "rearrange": "Rearrange tiles",
    "wholeDayLocked": "This date has no other shift yet, so there is nothing to take in.",
    "wholeDayHint": "Take in every other shift recorded on this date alongside this one.",
    "wholeDay": "Whole day",
    "emptyTitle": "No plant status",
    "empty": "No plant availability has been recorded for the selected date and shift.",
    "offline": "Plant availability is calculated by the server, so it cannot be shown while offline. It is available again once you reconnect.",
    "operatingDelayFormula": "Operating delay % = operating delay minutes ÷ engine minutes.",
    "operatingDelay": "Op. Delay",
    "vehicles": "Vehicles: {{vehicles}}",
    "uoa": "UoA: {{value}}",
    "availability": "Availability: {{value}}",
    "assetUtil": "Asset Util': {{value}}",
    "machines_one": "{{count}} machine",
    "machines_other": "{{count}} machines",
    "wholeDayScope": "whole day",
    "thisShift": "this shift",
    "machinesScope": "{{machines}}, {{scope}}",
    "avail": "Avail",
    "uoaShort": "UoA",
    "openInOperations": "Open in Operations",
    "openInStoppages": "Open in Stoppages",
    "since": "since {{time}}"
  },
  "targets": {
    "compareAgainst": "Compare against",
    "emptyTitle": "No targets to compare",
    "empty": "No targets are set for this date, or the figures they compare against have not loaded.",
    "pick": "Pick a metric above to show it.",
    "category": {
      "Forecast": "Forecast",
      "Plan": "Plan",
      "Budget": "Budget"
    }
  },
  "imports": {
    "emptyTitle": "No import data",
    "empty": "Nothing has been imported for the selected date.",
    "offline": "Import checks are calculated by the server, so they cannot be shown while offline.",
    "cleanTitle": "Imports look consistent",
    "clean_one": "All {{count}} machines agree between the Operating Hours and Fleet Utilization files for this date.",
    "clean_other": "All {{count}} machines agree between the Operating Hours and Fleet Utilization files for this date.",
    "needChecking_one": "{{count}} of {{checked}} machines need checking against the imported spreadsheets.",
    "needChecking_other": "{{count}} of {{checked}} machines need checking against the imported spreadsheets."
  },
  "hourly": {
    "pin": "Click to pin this hour",
    "unpin": "Unpin hour",
    "plantType": "Plant Type",
    "emptyTitle": "No hourly metrics",
    "noPlantTypes": "No plant types are available to display metrics for.",
    "empty": "There's no hourly data recorded for the selected plant, date and shift.",
    "bcmAxis": "BCM",
    "bcmTotal": "BCM Total",
    "productivity": "Productivity",
    "utilization": "Utilization",
    "availability": "Availability",
    "availabilityForecast": "Availability Forecast",
    "pinHint": "Click an hour to pin its readings and open the pages behind them."
  },
  "gauge": {
    "onTrack": "On track",
    "behind": "Behind",
    "noTarget": "No target",
    "inBand": "In band",
    "low": "Low",
    "high": "High",
    "notJudged": "Not judged",
    "hide": "Hide {{label}}"
  },
  "machinePositions": {
    "live": "Receiving live position updates"
  },
  "drillBlastToday": {
    "emptyTitle": "Nothing to show",
    "empty": "No drilling, blasts, open misfires or rigs coming due a service for the selected date.",
    "drillMetres": "Drill metres today",
    "ofTarget": "of {{target}} m {{category}}",
    "openMisfires": "Open misfires",
    "misfires_one": "{{reference}} · {{count}} misfire",
    "misfires_other": "{{reference}} · {{count}} misfires",
    "holes": "Holes {{holes}}",
    "blastsToday": "Blasts today",
    "fired": "Fired {{time}}",
    "fires": "Fires {{time}}",
    "exclusion": "exclusion {{metres}} m",
    "rigsDue": "Rigs coming due a service",
    "overdue": "{{hours}} h overdue",
    "toService": "{{hours}} h to service",
    "patternStatus": {
      "Designed": "Designed",
      "Drilling": "Drilling",
      "Drilled": "Drilled",
      "Charging": "Charging",
      "Charged": "Charged",
      "Fired": "Fired",
      "Closed": "Closed",
      "Cancelled": "Cancelled"
    }
  },
  "explosivesStock": {
    "emptyTitle": "No magazines",
    "empty": "There are no magazines you can see. An admin adds them on the Magazines page.",
    "waiting_one": "{{count}} waiting for an admin",
    "waiting_other": "{{count}} waiting for an admin",
    "stocktakeToApprove": "Stocktake to approve",
    "neq": "{{neq}} kg NEQ",
    "neqOfLicensed": "{{neq}} kg NEQ of {{licensed}} kg licensed",
    "batchWithLot": "{{material}} lot {{lot}}",
    "expired": "{{batch}}: {{quantity}} {{unit}} expired {{date}}",
    "useBy": "{{batch}}: {{quantity}} {{unit}} use by {{date}}"
  }
}
